import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
import moment from 'moment';
import PageTitle from '../../../../components/PageTitle';
import RouteNames from '../../../App/RouteNames';
import { uploadMultiPartFiles, saveOutputTemplateByType, getOutputTemplateByType } from '../../../App/actions';
import TitleFrom from '../../../../components/common/TitleFrom';
import { VoiceExcessTrafficReportSearchForm } from '../../../../components/ReportHub';
import {
  SwitchExport,
  DataTable,
  ExcelExport,
  TablePagination,
  ButtonExport,
  EmailGroup,
  DragDropConfigExportTemplate,
  ModalWithItem,
} from '../../../../components/common';
import { tabelColumnExportVoiceExcessTrafficReport, sortVoiceExcessTrafficReport } from '../../constants';
import { getExcessVoiceTraffic, getListAllExcessVoiceTraffic, onResetDefaultData } from '../../actions';
import { makeGetListExcessVoiceTraffic, makeGetListAllExcessVoiceTraffic } from '../../selectors';
import {
  getPageTotalCount,
  parseToMutationRequestPostMethod,
  blobToFile,
  validateEmail,
  blobToCSVFile,
  configOutputTemplateByType,
} from '../../../../utils/utils';
import convertJson2Sheet from '../../../../utils/ExcelHelper/exportExcelFile';
import convertJson2Pdf from '../../../../utils/PdfHelper/exportPdfFile';
import ModalCallType from '../../../../components/common/ModalCallType';
import ModalSearchMultiOrganization from '../../../../components/common/ModalSearchMultiOrganization';
import ModalMultipleAccountIds from '../../../../components/common/ModalMultipleAccountIds';
import { PAGE_SIZE_DOWNLOAD } from '../../../../utils/constants';

let tableColumnsOutput = null;

class VoiceExcessTrafficReport extends Component {
  state = {
    isActivePdf: false,
    page: 0,
    size: 20,
    filter: {},
    sort: '',
    sorted: {},
    totalCount: null,
    isSearching: false,
    listVoiceExcessTrafficReport: [],
  };

  buttonRef = React.createRef();

  static getDerivedStateFromProps(props, state) {
    return {
      listVoiceExcessTrafficReport: props.listVoiceExcessTrafficReport,
      totalCount: getPageTotalCount({ ...state, items: props.listVoiceExcessTrafficReport }),
    };
  }

  componentDidMount() {
    const {
      permissions: { modeGetExcessVoiceTrafficReport },
      onResetDefaultData,
    } = this.props;
    if (modeGetExcessVoiceTrafficReport) {
      this.doGetOutputTemplateByType();
      onResetDefaultData('listExcessVoiceTraffic');
    }
  }

  onSortColumn = (sortCol, sortDir) => {
    this.setState({ sorted: { sortCol, sortDir } }, () => {
      this.doGetListVoiceExcessTrafficReport();
    });
  };

  onPageChange = pageChange => {
    const { page } = this.state;
    if (page === pageChange) return '';
    return this.setState({ page: pageChange }, () => this.doGetListVoiceExcessTrafficReport());
  };

  onSizeChange = size => {
    this.setState({ size, page: 0 }, () => this.doGetListVoiceExcessTrafficReport());
  };

  onHandleSubmitSearch = filter => {
    this.setState({ filter: { ...filter }, page: 0 }, () => {
      this.doGetListVoiceExcessTrafficReport();
    });
  };

  doGetListVoiceExcessTrafficReport = () => {
    const { filter, page, size, sorted } = this.state;
    const { getExcessVoiceTraffic } = this.props;
    if (!filter.startDate) {
      filter.startDate = moment()
        .startOf('month')
        .format('YYYY-MM-DD HH:mm:ss');
    }
    if (!filter.endDate) {
      filter.endDate = moment()
        .endOf('month')
        .format('YYYY-MM-DD HH:mm:ss');
    }
    const payload = {
      page: page + 1,
      size,
      filter,
      sort:
        !isEmpty(sorted) && sortVoiceExcessTrafficReport[sorted.sortCol]
          ? sortVoiceExcessTrafficReport[sorted.sortCol][sorted.sortDir]
          : null,
    };
    this.setState({ isSearching: true });
    getExcessVoiceTraffic(payload, () => {
      this.setState({ isSearching: false });
    });
  };

  doGetAlllistVoiceExcessTrafficReport = cb => {
    const { filter, sorted } = this.state;
    const { getListAllExcessVoiceTraffic } = this.props;
    if (!filter.startDate) {
      filter.startDate = moment()
        .startOf('month')
        .format('YYYY-MM-DD HH:mm:ss');
    }
    if (!filter.endDate) {
      filter.endDate = moment()
        .endOf('month')
        .format('YYYY-MM-DD HH:mm:ss');
    }
    const payload = {
      page: 1,
      size: PAGE_SIZE_DOWNLOAD,
      filter,
      sort: !isEmpty(sorted) ? sortVoiceExcessTrafficReport[sorted.sortCol][sorted.sortDir] : null,
    };
    getListAllExcessVoiceTraffic(payload, () => {
      if (cb) cb();
    });
  };

  onChangeSwitch = () => {
    const { isActivePdf } = this.state;
    this.setState({ isActivePdf: !isActivePdf });
  };

  onExport = () => {
    this.doGetAlllistVoiceExcessTrafficReport(() => {
      const { isActivePdf } = this.state;
      if (isActivePdf) {
        const { listAllVoiceExcessTrafficReport, t } = this.props;
        convertJson2Pdf({
          data: listAllVoiceExcessTrafficReport,
          t,
          title: t('reportPage:sidebar.voiceExcessTrafficReport').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.voiceExcessTrafficReport')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          columnsTable: tableColumnsOutput,
          fontSize: 7,
        });
      } else {
        this.buttonRef.current.click();
      }
    });
  };

  sendEmail = ({ subject, emailBody }) => {
    this.doGetAlllistVoiceExcessTrafficReport(() => {
      const { listAllVoiceExcessTrafficReport, t, uploadMultiPartFiles } = this.props;
      const { emails, isActivePdf } = this.state;

      const query = `{"query": "mutation{sendReport(input: ${parseToMutationRequestPostMethod(
        {
          emailAddress: emails.join(', '),
          type: 'EXCESS_VOICE_TRAFFIC_REPORT',
          subject: subject || `Embrix Report ${t('reportPage:sidebar.voiceExcessTrafficReport')}`,
          emailBody,
        },
        ['type']
      )})}"}`;
      const formData = new FormData();

      if (!isActivePdf) {
        formData.append(
          'file',
          blobToCSVFile({
            fileName: `${t('reportPage:sidebar.voiceExcessTrafficReport')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}.csv`,
            data: listAllVoiceExcessTrafficReport,
            t,
            columns: tableColumnsOutput,
          })
        );
      } else {
        const pdfFile = convertJson2Pdf({
          data: listAllVoiceExcessTrafficReport,
          t,
          title: t('reportPage:sidebar.voiceExcessTrafficReport').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.voiceExcessTrafficReport')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          isFile: true,
          columnsTable: tableColumnsOutput,
          fontSize: 7,
        });
        formData.append(
          'file',
          blobToFile(
            pdfFile,
            `${t('reportPage:sidebar.voiceExcessTrafficReport')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`
          )
        );
      }

      formData.append('graphql', query);
      // formData.append('file', blobToFile(pdfFile, 'attachment'));
      uploadMultiPartFiles(
        formData,
        res => {
          if (res && res.success) {
            if (res.success) this.setState({ emails: [] });
          }
        },
        true
      );
    });
  };

  onChangeEmail = tags => {
    let isEmail = true;
    if (tags && tags.length) {
      tags.forEach(email => {
        if (!validateEmail(email)) {
          isEmail = false;
        }
      });
    }
    if (!isEmail) return '';

    return this.setState({ emails: tags });
  };

  doGetOutputTemplateByType = () => {
    const { getOutputTemplateByType, t } = this.props;
    getOutputTemplateByType('VOICE_EXCESS_TRAFFIC', ({ success, data }) => {
      if (success && data) {
        this.setState({
          exportColumnsSave: configOutputTemplateByType({
            columns: tabelColumnExportVoiceExcessTrafficReport,
            data,
            t,
          }),
          idOutputTemplate: data?.id,
          typeOutputTemplate: data?.type,
        });
      }
    });
  };

  onHandleSaveConfig = columns => {
    const { saveOutputTemplateByType } = this.props;
    const { idOutputTemplate, typeOutputTemplate } = this.state;
    const payload = {
      id: idOutputTemplate,
      type: typeOutputTemplate,
      source: columns.sourceFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
      target: columns.targetFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
    };

    saveOutputTemplateByType(payload, ({ success }) => {
      if (success) {
        this.doGetOutputTemplateByType();
        this.setState({ exportColumnsSave: columns, isOpenModalExportConfig: false });
      }
    });
  };

  onToggleModalExportConfig = () => {
    const { isOpenModalExportConfig } = this.state;
    this.setState({ isOpenModalExportConfig: !isOpenModalExportConfig });
  };

  render() {
    const {
      isSearching,
      isActivePdf,
      sorted,
      page,
      size,
      totalCount,
      listVoiceExcessTrafficReport,
      emails,
      exportColumnsSave,
      isOpenModalExportConfig,
    } = this.state;
    const {
      listAllVoiceExcessTrafficReport,
      t,
      permissions: { modeGetExcessVoiceTrafficReport, modeDownloadReport, modeGetMailReport },
    } = this.props;
    if (!modeGetExcessVoiceTrafficReport) return '';
    const exportColumns = exportColumnsSave || {};
    tableColumnsOutput = exportColumns?.targetFields?.items || [];
    return (
      <div className="col-md-12">
        <PageTitle
          linkTo={RouteNames.report.path}
          titleBtn="back"
          items={[
            { name: t('label.report'), url: RouteNames.report.path },
            { name: t('reportPage:sidebar.voiceExcessTrafficReport') },
          ]}
        />
        <br />
        <div className="card card-statistics mb-30">
          <TitleFrom title={t('reportPage:sidebar.voiceExcessTrafficReport')} />
          <div className="col-md-12 mb-30">
            <div className="card-body">
              <div className="pl-2">
                <VoiceExcessTrafficReportSearchForm
                  onSubmit={this.onHandleSubmitSearch}
                  ModalSearch={props => {
                    return (
                      <div>
                        <ModalCallType
                          isOpen={props.isOpen === 'usageType'}
                          onSelect={props.onSelect}
                          onCancel={props.onToggle}
                        />
                        <ModalSearchMultiOrganization
                          isOpen={props.isOpen === 'organization'}
                          onSelect={props.onSelect}
                          onCancel={props.onToggle}
                          selectFieldName="organization"
                          // childrenField="accountId"
                          // onSelectChild={props.onSelectChild}
                          // selectChildFieldName="id"
                        />
                        <ModalMultipleAccountIds
                          isOpen={props.isOpen === 'accountId'}
                          onSelect={props.onSelect}
                          onCancel={props.onToggle}
                        />
                      </div>
                    );
                  }}
                />
              </div>
              <div>
                <div className="mt-3 col-md-12 row mb-4 pt-3 pb-3">
                  <button
                    type="submit"
                    onClick={this.onToggleModalExportConfig}
                    className="button x-small mr-2 btn-config"
                  >
                    {/* {t('label.outputConfig')} */}
                    <i className="ti-list" />
                  </button>
                  {!!modeDownloadReport && (
                    <div className="ml-auto mt-2 mb-auto mr-3">
                      <SwitchExport
                        onChange={this.onChangeSwitch}
                        wrapperClass={isActivePdf ? 'switch-active' : 'switch-non-active'}
                        title={t('label.excel')}
                        checked={isActivePdf}
                        rightTitle={t('label.pdf')}
                      />
                    </div>
                  )}
                  {!!modeDownloadReport && (
                    <>
                      <ButtonExport onExport={this.onExport} />
                      <ExcelExport
                        element={<button type="button" className="display-none" ref={this.buttonRef} />}
                        nameSheet={t('reportPage:sidebar.voiceExcessTrafficReport').toLocaleUpperCase()}
                        multiDataSet={convertJson2Sheet({
                          data: listAllVoiceExcessTrafficReport,
                          t,
                          title: t('reportPage:sidebar.voiceExcessTrafficReport').toLocaleUpperCase(),
                          columnsTable: tableColumnsOutput,
                        })}
                        fileName={`${t('reportPage:sidebar.voiceExcessTrafficReport')
                          .toLocaleLowerCase()
                          .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`}
                      />
                    </>
                  )}
                  {modeGetMailReport !== 0 && (
                    <EmailGroup
                      emails={emails}
                      onChangeEmail={this.onChangeEmail}
                      sendEmail={this.sendEmail}
                      data={listVoiceExcessTrafficReport}
                    />
                  )}
                </div>
                <DataTable
                  columns={tableColumnsOutput}
                  data={
                    listVoiceExcessTrafficReport && listVoiceExcessTrafficReport.length
                      ? listVoiceExcessTrafficReport
                      : []
                  }
                  onSort={this.onSortColumn}
                  sorted={sorted}
                  isLoading={isSearching}
                  isFixedHeaderTable
                />
              </div>
            </div>
          </div>
        </div>
        <div className="mb-30">
          <TablePagination
            pageNumber={page}
            pageSize={size}
            totalCount={totalCount}
            onPageChange={this.onPageChange}
            onSizeChange={this.onSizeChange}
          />
        </div>
        <ModalWithItem
          onToggle={this.onToggleModalExportConfig}
          isOpen={isOpenModalExportConfig}
          wrapperClass="modal-config"
        >
          <div className="col-md-12 d-flex">
            <div className="column-config" onClick={this.onToggleModalExportConfig} />
            <div className="body-config">
              <DragDropConfigExportTemplate
                onHandleSave={this.onHandleSaveConfig}
                exportColumns={exportColumns}
                onToggle={this.onToggleModalExportConfig}
              />
            </div>
          </div>
        </ModalWithItem>
      </div>
    );
  }
}

VoiceExcessTrafficReport.propTypes = {
  getExcessVoiceTraffic: PropTypes.func,
  getListAllExcessVoiceTraffic: PropTypes.func,
  listAllVoiceExcessTrafficReport: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.any),
    PropTypes.objectOf(PropTypes.any),
  ]),
};

VoiceExcessTrafficReport.defaultProps = {
  getExcessVoiceTraffic: () => {},
  getListAllExcessVoiceTraffic: () => {},
  listAllVoiceExcessTrafficReport: [],
};

const mapStateToProps = createStructuredSelector({
  listVoiceExcessTrafficReport: makeGetListExcessVoiceTraffic() || [],
  listAllVoiceExcessTrafficReport: makeGetListAllExcessVoiceTraffic() || [],
});
export default withTranslation('common')(
  connect(mapStateToProps, {
    getExcessVoiceTraffic,
    getListAllExcessVoiceTraffic,
    uploadMultiPartFiles,
    saveOutputTemplateByType,
    getOutputTemplateByType,
    onResetDefaultData,
  })(VoiceExcessTrafficReport)
);
